import { api_instance_auth } from ".";

export const logoutAPI = async () => {
  const response = await api_instance_auth.get("/user/logout");
  return response;
};

export const userInfoAPI = async () => {
  const response = await api_instance_auth.get("/user/get-user-profile");
  return response;
};

export const changePasswordAPI = async (body) => {
  const response = await api_instance_auth.post("/user/change-password", body);
  return response;
};

export const createUser = async (body) => {
  const response = await api_instance_auth.post("/user/add", body);
  return response;
};

export const updatedUser = async (body, id) => {
  const response = await api_instance_auth.patch(`/user/edit/${id}`, body);
  return response;
};

export const listUsers = async ({ search, order, sort, limit, page }) => {
  const response = await api_instance_auth.post("/user/list", {
    search: search,
    order: order,
    sort: "createdAt",
    limit: 10,
    page: 1,
  });
  return response;
};

export const deleteUser = async (id) => {
  const response = await api_instance_auth.delete(`/user/${id}`);
  return response;
};

export const updatedStatus = async (status, id) => {
  const response = await api_instance_auth.patch(`/user/edit/${id}`, {
    status: status,
  });
  return response;
};

export const resetPassword = async ({
  id,
  newPassword,
  confirmNewPassword,
}) => {
  const response = await api_instance_auth.patch(`/user/reset-password/${id}`, {
    newPassword,
    confirmNewPassword,
  });
  return response;
};
